export default "__VITE_ASSET__Blol_P5N__"